import type { FaireProductEntity } from "../../entity_types/product";

export const p_mnnsjdftyx: FaireProductEntity = {
  token: "p_mnnsjdftyx",
  type: "product",
  name: "Cactus Hand Cream - Bosque Místico (Pack of 12)",
  brandToken: "b_c3hepkjc1t",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/6bb334506f5be98ca2ade912e314cbb0555e838d0932824bad15aeeea1808ae4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6656c3f0a3c78a2e64b2d47e608193a61fc612399b9c3e6d5edf4c4c4046277.jpeg",
    "https://cdn.faire.com/fastly/f16eef10cd936127ad92bc4ae894d976ec4b105cdb67b972d62015cd26372366.jpeg",
    "https://cdn.faire.com/fastly/2820f6860aff9e9de7ee4dce2e5919e97c799f32b5da1ddfc4b6b530e0229185.jpeg",
    "https://cdn.faire.com/fastly/c304f940e0994b7da4908ca199e069494448937f7a3afa9bac21e66099c89b70.jpeg",
    "https://cdn.faire.com/fastly/8fa24c60615606a12ebbba963500007894276e529b14c66dd3caf3d591e4eb60.jpeg",
    "https://cdn.faire.com/fastly/36b73e83221dc29600382e211facc89e4742d093ba910d5ebfff2b19d97844a0.png",
  ],
  priceDollars: 84,
  description:
    "Pack exclusive for wholesale.\n12 x 1.5 oz | 42 g\n\nA travel-friendly must-have. This ultra-luxurious nourishing hand cream delivers deep, everyday hydration, powered by native Mexican prickly pear oil. Enriched with Vitamin E and K for anti-inflammatory benefits, our signature ingredient leaves skin hydrated, protected, and strengthened.\n\nVegan | Dermatologist Tested | Safe for Sensitive Skin\n\n\nBENEFITS\n\n * Long-Lasting Hydration (72 hours) \n * Non-greasy \n * Fast-absorbing\n",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:32.134Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
